import * as actionTypes from '../consts/actionTypes';
import {responseToReturn} from '../../utils/utilsFunctions.js'

const initialState = {
    allCredentials: [],
    msgError: ''
};

export default function credentialReducer(state = initialState, action) {
    const DEFAULT = { ...state };
    const ACTIONS = {
        [actionTypes.SUCCESS_GET_ALL_CREDENTIALS]: responseToReturn('allCredentials', state, action),
        [actionTypes.FAILURE_GET_ALL_CREDENTIALS]: responseToReturn('', state, action),
    };

    let receiveAction = DEFAULT;

    if (ACTIONS[action.type] !== undefined) {
        receiveAction = ACTIONS[action.type];
    }

    return receiveAction;
}